

































import Vue from 'vue';
import store from '@/store';
import { WorkflowStep } from '@/store/getStarted';

export default Vue.extend({
  name: 'SetNameStep',

  data(): { userName: string } {
    return {
      userName: ''
    };
  },

  computed: {
    nameIsReadOnly(): boolean {
      return !!store.getters.getStarted.name;
    },

    userNameFromStore(): string {
      return store.getters.getStarted.name;
    }
  },

  methods: {
    async submitName() {
      if (!this.userName) return;

      if (this.nameIsReadOnly) {
        store.dispatch.getStarted.goToStep(
          WorkflowStep.CHOOSE_GO_TO_EXISTING_ORG_OR_CREATE
        );
        return;
      }

      await store.dispatch.getStarted.setUserName(this.userName);
    }
  },

  watch: {
    userNameFromStore: {
      immediate: true,
      handler(val) {
        if (val) {
          this.userName = val;
        }
      }
    }
  }
});
